import { Component, OnInit } from '@angular/core';
import { IncidentsPageStateService } from '../../services';

@Component({
  templateUrl: './incidents-page.component.html',
})
export class IncidentsPageComponent implements OnInit {
  constructor(public stateService: IncidentsPageStateService) {}

  ngOnInit(): void {}
}
